<template>
    <PanelFirmas></PanelFirmas>
</template>
<script>
import PanelFirmas from '../components/PanelFirmas.vue';
export default {
    name: 'UserDocumentView',
    components: {
        PanelFirmas,
    }
}
</script>